import interceptorAxios from './InterceptorAxios';

const ServicioEnvioCorreo= {

    enviar_cfdis_correo(objeto){
        return interceptorAxios.post('/correo/enviar_cfdis.json',objeto)
    },
    enviar_a_mi_correo(objeto){
        return interceptorAxios.post('/correo/enviar_a_mi_correo.json',objeto)
    },
    enviaAfilPorCorreo(){
        return interceptorAxios.post("/correo/enviar_afil.json")
    }
}

export default ServicioEnvioCorreo;